const transformState = ({state, goingIn, gettingOut}) => ({
    value: goingIn(state.value),
    onChange: (v) => state.onChange(gettingOut(v)),
    ...(state.change && {
        change: (reducer) => state.change((s) => gettingOut(reducer(s))),
    }),
});
exports.transformState = transformState;
